import { YATTA_PRIVACY_POLICY_URL, YATTA_TERMS_OF_SERVICE_URL } from '@platform-frontend/platform';
import { YattaExternalLink } from '@platform-frontend/util';

export const TERMS_AND_PRIVACY_POLICY_LINKS: { termsLink: YattaExternalLink; privacyPolicyLink: YattaExternalLink } = {
  termsLink: { url: YATTA_TERMS_OF_SERVICE_URL, class: 'link link-secondary link-underline', target: '_blank', id: '8f61d322-6ca1-4107-bf7a-465e63af2580' },
  privacyPolicyLink: {
    url: YATTA_PRIVACY_POLICY_URL,
    class: 'link link-secondary link-underline',
    target: '_blank',
    id: '874e2c07-576f-4dcc-86fa-9792e42956b7'
  }
};
